// removed by extract-text-webpack-plugin
module.exports = {"ChartAndDetail":"_2I4qY","Chart":"_1rcAr","Detail":"n71oW","Donut":"_2Gb1p","Value":"_2tU5X","Title":"-GCLu"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/PieChart.css
// module id = 474
// module chunks = 3 4 5